import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { PhoneNumber, PhoneNumberUtil } from "google-libphonenumber";

export const isPhoneNumber: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const countryPrefix: AbstractControl = control.get('countryPrefix');
    const number: AbstractControl = control.get('number');
    const phoneNumberUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();

    if (countryPrefix.value && number.value) {
        try {
            const phoneNumber: PhoneNumber = phoneNumberUtil.parseAndKeepRawInput(
                number.value, countryPrefix.value
            );

            const isValidNumber: boolean = phoneNumberUtil.isValidNumber(phoneNumber);
            if (isValidNumber) {
                return null;
            }

            return { isNotValidPhoneNumber: number.value };
        } catch (error) {
            return { isNotValidPhoneNumber: number.value };
        }
    }

    // If there is not a number
    return null;
};
